(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('announcement-bar')) {
    customElements.define('announcement-bar', class extends HTMLElement {
      connectedCallback() {
        var key = 'announcement-dismissed';
        var dismissed = false;
        try { dismissed = localStorage.getItem(key) === this.dataset.key; } catch (e) {}
        this.hidden = dismissed && !(window.Shopify && Shopify.designMode);

        var btn = this.querySelector('.announcement-bar__close');
        if (btn) {
          btn.addEventListener('click', function () {
            this.hidden = true;
            try { localStorage.setItem(key, this.dataset.key); } catch (e) {}
          }.bind(this));
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('before-after')) {
    customElements.define('before-after', class extends HTMLElement {
      connectedCallback() {
        var range = this.querySelector('.before-after__range');
        if (!range) return;
        var update = function () { this.style.setProperty('--position', range.value + '%'); }.bind(this);
        range.addEventListener('input', update);
        update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        var self = this;
        var onCartPage = window.location.pathname === this.dataset.cartUrl;

        document.addEventListener('click', function (e) {
          var cartLink = e.target.closest('#header-cart-link');
          if (cartLink && !onCartPage) {
            e.preventDefault();
            self.refresh().then(function () { self.open(); });
          }
        });

        document.addEventListener('submit', function (e) {
          var form = e.target;
          if (onCartPage || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
          e.preventDefault();
          fetch(self.dataset.cartAddUrl, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          })
            .then(function (r) {
              if (!r.ok) throw new Error('add failed');
              return self.refresh();
            })
            .then(function () { self.open(); })
            .catch(function () { form.submit(); });
        });

        this.addEventListener('click', function (e) {
          if (e.target === self.dialog || e.target.closest('[data-cart-close]')) {
            self.dialog.close();
            return;
          }
          var qty = e.target.closest('[data-cart-qty]');
          if (qty) {
            fetch(self.dataset.cartChangeUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ line: Number(qty.dataset.line), quantity: Number(qty.dataset.quantity) })
            }).then(function () { return self.refresh(); }).catch(function () {});
          }
        });

        this.addEventListener('change', function (e) {
          if (e.target.id !== 'cart-drawer-note') return;
          fetch(self.dataset.cartUpdateUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ note: e.target.value })
          }).catch(function () {});
        });
      }

      open() {
        if (this.dialog && !this.dialog.open) this.dialog.showModal();
      }

      refresh() {
        var self = this;
        return fetch(this.dataset.rootUrl + '?sections=cart-drawer')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
            var fresh = doc.getElementById('cart-drawer-inner');
            var current = self.querySelector('#cart-drawer-inner');
            if (!fresh || !current) return;
            current.replaceWith(fresh);
            var badge = document.getElementById('header-cart-count');
            if (badge) {
              var count = Number(fresh.dataset.itemCount);
              badge.textContent = count;
              badge.hidden = count === 0;
            }
          });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.querySelectorAll('.cart-item__qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = this.closest('.cart-item__qty').querySelector('.cart-item__qty-input');
      if (!input) return;
      var val = parseInt(input.value) || 0;
      if (this.dataset.action === 'plus') {
        input.value = val + 1;
      } else if (this.dataset.action === 'minus') {
        input.value = Math.max(0, val - 1);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function () {
    var sort = document.getElementById('collection-sort');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    var dialog = document.getElementById('collection-filters');
    var openBtn = document.getElementById('collection-filters-open');
    var closeBtn = document.getElementById('collection-filters-close');
    if (dialog && openBtn) {
      openBtn.addEventListener('click', function () { dialog.showModal(); });
      if (closeBtn) closeBtn.addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    var header = document.getElementById('site-header');
    var toggle = document.getElementById('mobile-menu-toggle');
    var menu = document.getElementById('mobile-menu');
    var closeBtn = document.getElementById('mobile-menu-close');

    if (header) {
      var onScroll = function () {
        header.classList.toggle('site-header--shrunk', window.scrollY > 40);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    var searchDialog = document.getElementById('search-dialog');
    var searchOpen = document.getElementById('search-open');
    var searchInput = document.getElementById('search-input');
    var searchResults = document.getElementById('search-results');
    if (searchDialog && searchOpen) {
      searchOpen.addEventListener('click', function () {
        searchDialog.showModal();
        searchInput.focus();
      });
      document.getElementById('search-close').addEventListener('click', function () { searchDialog.close(); });
      searchDialog.addEventListener('click', function (e) { if (e.target === searchDialog) searchDialog.close(); });

      var timer;
      var controller;
      searchInput.addEventListener('input', function () {
        clearTimeout(timer);
        var q = searchInput.value.trim();
        if (q.length < 2) { searchResults.replaceChildren(); return; }
        timer = setTimeout(function () {
          if (controller) controller.abort();
          controller = new AbortController();
          var url = searchInput.dataset.suggestUrl + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5';
          fetch(url, { signal: controller.signal })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              var products = (data.resources && data.resources.results && data.resources.results.products) || [];
              var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
              var fmt = new Intl.NumberFormat('en-IN', { style: 'currency', currency: currency, maximumFractionDigits: 0 });
              var items = products.map(function (p) {
                var li = document.createElement('li');
                var a = document.createElement('a');
                a.href = p.url;
                a.className = 'search-dialog__result';
                var img = document.createElement('img');
                img.width = 56;
                img.height = 70;
                img.loading = 'lazy';
                img.alt = '';
                if (p.image) img.src = p.image;
                var title = document.createElement('span');
                title.textContent = p.title;
                var price = document.createElement('span');
                price.className = 'search-dialog__price';
                price.textContent = fmt.format(parseFloat(p.price));
                a.append(img, title, price);
                li.appendChild(a);
                return li;
              });
              searchResults.replaceChildren.apply(searchResults, items);
            })
            .catch(function () {});
        }, 200);
      });
    }

    if (header && header.classList.contains('site-header--transparent')) {
      window.addEventListener('scroll', function () {
        if (window.scrollY > 60) {
          header.classList.add('site-header--scrolled');
        } else {
          header.classList.remove('site-header--scrolled');
        }
      }, { passive: true });
    }

    if (toggle && menu) {
      toggle.addEventListener('click', function () {
        menu.showModal();
        toggle.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          menu.close();
          toggle.setAttribute('aria-expanded', 'false');
          document.body.style.overflow = '';
        });
      }

      menu.addEventListener('click', function (e) {
        if (e.target === menu) {
          menu.close();
          toggle.setAttribute('aria-expanded', 'false');
          document.body.style.overflow = '';
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var template = document.getElementById('hero-video-template');
    var controls = document.querySelector('.hero__video-controls');
    var btn = document.getElementById('hero-video-btn');
    if (!template || !btn) return;

    var wide = window.matchMedia('(min-width: 750px)');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!wide.matches || reduced.matches) return;

    var background = template.parentNode;
    background.appendChild(template.content.cloneNode(true));
    var video = document.getElementById('hero-bg-video');
    if (!video) return;
    controls.hidden = false;
    video.play().catch(function () {});

    var iconPause = btn.querySelector('.hero__video-btn-icon--pause');
    var iconPlay  = btn.querySelector('.hero__video-btn-icon--play');

    btn.addEventListener('click', function () {
      var paused = !video.paused;
      if (paused) video.pause(); else video.play();
      iconPause.style.display = paused ? 'none' : '';
      iconPlay.style.display = paused ? '' : 'none';
      btn.setAttribute('aria-pressed', String(paused));
      btn.setAttribute('aria-label', paused ? btn.dataset.labelPlay : btn.dataset.labelPause);
    });

    /* Pause when hero scrolls out of view to save resources */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (btn.getAttribute('aria-pressed') !== 'true') video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.2 }).observe(video.closest('.hero'));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    var track = document.getElementById('product-gallery-track');
    var gallery = document.getElementById('product-gallery');
    var variantSelect = document.getElementById('product-variant-id');
    var priceEl = document.getElementById('product-price');
    var addBtn = document.getElementById('product-add-btn');
    var stickyBar = document.getElementById('product-sticky');
    var stickyBtn = document.getElementById('product-sticky-btn');
    var stickyPrice = document.getElementById('product-sticky-price');
    var stickyVariant = document.getElementById('product-sticky-variant');
    var dynamicCheckout = document.getElementById('product-dynamic-checkout');
    var preorder = document.getElementById('product-preorder');
    var preorderLink = document.getElementById('product-preorder-link');
    var optionInputs = document.querySelectorAll('.product-page__option-input');

    var slides = track ? Array.from(track.children) : [];
    var markers = gallery ? gallery.querySelectorAll('.product-gallery__dot, .product-gallery__thumb') : [];
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function markActive(mediaId) {
      markers.forEach(function (m) {
        if (m.dataset.mediaId === mediaId) m.setAttribute('aria-current', 'true');
        else m.removeAttribute('aria-current');
      });
    }

    function goToMedia(mediaId, instant) {
      var slide = slides.find(function (el) { return el.dataset.mediaId === mediaId; });
      if (!slide || !track) return;
      track.scrollTo({
        left: slide.offsetLeft - track.offsetLeft,
        behavior: instant || reduceMotion ? 'auto' : 'smooth'
      });
      markActive(mediaId);
    }

    if (track && slides.length) {
      var initial = slides[0].dataset.mediaId;
      var initialId = gallery.dataset.initialMedia;
      if (slides.some(function (el) { return el.dataset.mediaId === initialId; })) initial = initialId;
      goToMedia(initial, true);

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) markActive(entry.target.dataset.mediaId);
          });
        }, { root: track, threshold: 0.6 });
        slides.forEach(function (el) { observer.observe(el); });
      }

      markers.forEach(function (m) {
        m.addEventListener('click', function () { goToMedia(this.dataset.mediaId); });
      });

      var dialog = document.getElementById('product-gallery-dialog');
      var zoomImg = document.createElement('img');
      zoomImg.width = 2000;
      zoomImg.height = 2500;
      if (dialog) dialog.appendChild(zoomImg);
      track.addEventListener('click', function (e) {
        var btn = e.target.closest('.product-gallery__zoom');
        if (!btn || !dialog || !dialog.showModal) return;
        zoomImg.src = btn.dataset.zoomSrc;
        zoomImg.alt = btn.dataset.zoomAlt || '';
        dialog.showModal();
      });
      if (dialog) {
        dialog.addEventListener('click', function () { dialog.close(); });
      }
    }

    function showVariantImage(mediaId) {
      if (mediaId) goToMedia(mediaId);
    }

    var qtyInput = document.querySelector('.product-page__qty-input');
    document.querySelectorAll('.product-page__qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var val = parseInt(qtyInput.value) || 1;
        if (this.dataset.action === 'plus') {
          qtyInput.value = val + 1;
        } else if (this.dataset.action === 'minus' && val > 1) {
          qtyInput.value = val - 1;
        }
      });
    });

    function updateVariant() {
      if (!variantSelect) return;
      var selected = variantSelect.options[variantSelect.selectedIndex];
      if (!selected) return;

      var priceFormatted = selected.dataset.priceFormatted || '';
      var comparePriceFormatted = selected.dataset.comparePriceFormatted || '';
      var comparePrice = parseInt(selected.dataset.comparePrice) || 0;
      var price = parseInt(selected.dataset.price) || 0;
      var available = selected.dataset.available === 'true';

      showVariantImage(selected.dataset.mediaId);

      if (priceEl) {
        if (comparePrice > price) {
          var pct = Math.round((comparePrice - price) * 100 / comparePrice);
          priceEl.innerHTML =
            '<span class="product-page__price-sale">' + priceFormatted + '</span>' +
            '<s class="product-page__price-compare">' + comparePriceFormatted + '</s>' +
            '<span class="product-page__price-badge">-' + pct + '%</span>';
        } else {
          priceEl.innerHTML = '<span class="product-page__price-regular">' + priceFormatted + '</span>';
        }
      }

      var label = available ? addBtn.dataset.addLabel : addBtn.dataset.soldLabel;
      [addBtn, stickyBtn].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = !available;
        btn.textContent = label;
      });

      if (stickyPrice) stickyPrice.textContent = priceFormatted;
      if (stickyVariant) stickyVariant.textContent = selected.dataset.title;
      if (dynamicCheckout) dynamicCheckout.hidden = !available;
      if (preorder) preorder.hidden = available;

      if (preorderLink) {
        var message = preorderLink.dataset.template
          .replace('__PRODUCT__', preorderLink.dataset.product)
          .replace('__VARIANT__', selected.dataset.title)
          .replace('__URL__', preorderLink.dataset.url);
        preorderLink.href = preorderLink.dataset.base + encodeURIComponent(message);
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var optionIndex = this.closest('.product-page__option').querySelector('[data-option-index]');
        if (optionIndex) { optionIndex.textContent = this.value; }

        this.closest('.product-page__pills, .product-page__swatches')
          ?.querySelectorAll('label')
          .forEach(function (l) {
            l.classList.remove('product-page__pill--active', 'product-page__swatch--active');
          });
        this.parentElement.classList.add(
          this.parentElement.closest('.product-page__pills') ? 'product-page__pill--active' : 'product-page__swatch--active'
        );

        if (variantSelect) {
          var values = [];
          document.querySelectorAll('.product-page__option').forEach(function (opt) {
            var checked = opt.querySelector('input:checked');
            if (checked) values.push(checked.value);
          });
          Array.from(variantSelect.options).forEach(function (option) {
            var parts = option.dataset.options.split('|');
            if (values.every(function (v, i) { return parts[i] === v; })) {
              variantSelect.value = option.value;
            }
          });
          updateVariant();
        }
      });
    });

    /* Description opens by default on desktop only */
    var descriptionDetails = document.getElementById('product-description-details');
    if (descriptionDetails && window.matchMedia('(min-width: 900px)').matches) {
      descriptionDetails.open = true;
    }

    /* Sticky add to cart appears once the main button leaves the viewport */
    if (stickyBar && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var pastButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyBar.hidden = !pastButton;
        document.documentElement.classList.toggle('has-sticky-cart', pastButton);
      }).observe(addBtn);
    }
  })();

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', class extends HTMLElement {
      connectedCallback() {
        var url = this.dataset.url;
        if (!url || this.children.length) return;
        fetch(url)
          .then(function (response) { return response.ok ? response.text() : ''; })
          .then(function (text) {
            var doc = new DOMParser().parseFromString(text, 'text/html');
            var fresh = doc.querySelector('product-recommendations');
            if (fresh && fresh.children.length) this.innerHTML = fresh.innerHTML;
          }.bind(this))
          .catch(function () {});
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
